import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import DashboardBanner from 'rebook/apps/dashboard/components/DashboardBanner';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


class DashboardBannerBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;
    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBannerDetail();
  }

  fetchBannerDetail() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = this.state.block.resource_uri;
    this.props.DashboardBlockListActions.fetchDashboardBlock(url)
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                banner: data,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard banner due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;

    return (
      get(dashboardBlockList[blockId], 'banner', null)
        ? <DashboardBanner {...dashboardBlockList[blockId].banner} />
        : null
    );
  };
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBannerBlock.propTypes = {
  block: PropTypes.shape({
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBannerBlock);
